//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _willCreate_metadata_changeHistory from './willCreate_metadata_changeHistory';
export const willCreate_metadata_changeHistory = _willCreate_metadata_changeHistory;
export default {willCreate_metadata_changeHistory};

